import {config} from '@modules/config';

const SEGMENT_API_KEY_CONFIG = 'segment_api_key';

export const getSegmentWriteKey = (): string | null => {
	let rawWriteKey: unknown;
	try {
		rawWriteKey = config.get(SEGMENT_API_KEY_CONFIG as never);
	} catch (error) {
		if (
			error instanceof Error &&
			error.message === `Missing config ${SEGMENT_API_KEY_CONFIG}`
		) {
			return null;
		}
		throw error;
	}

	const writeKey = typeof rawWriteKey === 'string' ? rawWriteKey.trim() : '';
	return writeKey.length > 0 ? writeKey : null;
};
